import React from "react";
import { Box, Typography } from "@mui/material";
import { Button, getImage, InputField } from "@dishopsaas/design-system";
import { PRIMARY, TRANSPARENT } from "../../constants";
import getStyles from "./Modal.styles";
import Spinner from "../Spinner";
import { ModalProps } from "../../1_types/signUpTypes";

const Modal: React.FC<ModalProps> = ({
  title,
  subtitle,
  icon,
  formContent,
  inputField,
  primaryButton,
  secondaryButton,
  errorMessage,
  isLoading,
}) => {
  const styles = getStyles();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ marginBottom: "40px" }}>
        <Box style={styles.topContainer}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {getImage(icon, { size: 70 })}
          </Box>

          <Typography variant='h4' sx={styles.title}>{title}</Typography>
        </Box>
        <Box>
          <Typography variant='body2' sx={styles.subtitle}>{subtitle}</Typography>
        </Box>
      </Box>

      {errorMessage && (
        <Box sx={{ mb: 3 }}>
          <Typography
            color="error"
            variant="caption"
            sx={{ textAlign: "center" }}
          >
            {errorMessage}
          </Typography>
        </Box>
      )}

      <Box sx={{ marginBottom: "40px" }}>
        {formContent ? (
          formContent
        ) : inputField ? (
          <InputField
            label={inputField.label}
            value={inputField.value}
            onChange={inputField.onChange}
            placeholder={inputField.placeholder}
            error={inputField.error}
            helperText={inputField.helperText}
            inputProps={inputField.inputProps}
            leftIcon={inputField.leftIcon}
            labelAdornment={inputField.labelAdornment}
          />
        ) : null}
      </Box>

      {isLoading ? (
        <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
          <Spinner />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
          }}
        >
          <Button
            label={primaryButton.label}
            colorType={PRIMARY}
            sx={{ width: "100%" }}
            disabled={primaryButton.disabled}
            onClick={primaryButton?.onClick}
            loading={primaryButton.loading}
            type={primaryButton.type}
          />

          {secondaryButton && (
            <Box sx={{ textAlign: "center" }}>
              <Button
                label={secondaryButton.label}
                colorType={TRANSPARENT}
                leftIcon="ChevronLeft"
                sx={{ width: "100%" }}
                withoutHover
                onClick={secondaryButton.onClick}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Modal;
